import React from 'react';
import styles from './DownloadComponent.module.css';

const DownloadComponent = ({ brochure, userGuide }) => {
  const brochureIcon = 'Assets/Images/axlOneView/brochure.svg';
  const manualIcon = 'Assets/Images/axlOneView/manual.svg';
  
  return (
    <div className={styles.container}>
      {/* Brochure Download - Only show if brochure exists */}
      {brochure?.length > 0 && (
        <a href={brochure} className={styles.downloadItem} download target="_blank" rel="noopener noreferrer">
          <div className={styles.textWrapper}>
            <span className={styles.subtitle}>Click to Download</span>
            <span className={styles.title}>Brochure</span>
          </div>
          <div className={styles.iconSection}>
            <img 
              src={brochureIcon} 
              alt="Brochure Icon"
              className={styles.icon}
            />
          </div>
        </a>
      )}

      {/* User Manual Download - Only show if userGuide exists */}
      {userGuide?.length > 0 && (
        <a href={userGuide} className={styles.downloadItem} download="axl_Peregrine_2025.2.pdf" target="_blank" rel="noopener noreferrer">
          <div className={styles.iconSectionBlue}>
            <img 
              src={manualIcon} 
              alt="User Manual Icon"
              className={styles.icon}
            />
          </div>
          <div className={styles.textWrapper}>
            <span className={styles.subtitle}>Click to Download</span>
            <span className={styles.title}>User Manual</span>
          </div>
        </a>
      )}
    </div>
  );
};

export default DownloadComponent;